module.exports = __webpack_public_path__ + "img/f4.8be861af.png";